import { Component, inject, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { ErrorComponent } from 'src/common/directives/error/error.component';
import { AM_I_BOT } from 'src/common/helpers/whichBot';
import { APIService } from 'src/common/services/api.service';
import { AuthService } from 'src/common/services/auth.service';
import { PageService } from 'src/common/services/page.service';

declare const FRONTEND_PACKAGE_VERSION: string;

@Component({
  selector: 'ccf-root',
  imports: [RouterOutlet, ErrorComponent],
  template: `<router-outlet></router-outlet>

    @if (!isBot) {
      <ccf-error-alert></ccf-error-alert>
    } `,
})
export class RootComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly pageService = inject(PageService);
  private readonly authService = inject(AuthService);
  public readonly apiService = inject(APIService);

  isBot: boolean = AM_I_BOT;

  constructor() {
    self.CCF.LOADED = true;

    if (!this.isBot) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      window.DD_RUM.onReady(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        window.DD_RUM.init({
          clientToken: 'pub64e10d7c235dd5067a3cf4f6fcb25d39',
          applicationId: 'd5f82101-2263-4f31-9fa8-fbdb9668e60e',
          site: 'us3.datadoghq.com',
          service: 'charlies-website',
          env: window.isDev ? 'dev' : 'prod',
          // Specify a version number to identify the deployed version of your application in Datadog
          version: FRONTEND_PACKAGE_VERSION,
          sessionSampleRate: 10,
          sessionReplaySampleRate: 100,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input',
        });

        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        window.DD_RUM.startSessionReplayRecording();
      });
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    window.DD_LOGS.onReady(() => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      window.DD_LOGS.setGlobalContextProperty('version', FRONTEND_PACKAGE_VERSION);
    });
  }

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      this.pageService.resetTitle();
    });

    this.apiService.loginRequiredStream().subscribe((status?: boolean) => {
      if (typeof status !== 'undefined') {
        if (status) {
          const dialogRef = this.authService.promptLogin({ blocking: true });

          void dialogRef
            .afterClosed()
            .toPromise()
            .then((result) => {
              if (result) {
                this.apiService.requeuePendingAuth();
                this.apiService.processRequests();
              } else {
                window.location.pathname = '/';
              }
            });
        }
      }
    });
  }
}
